"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    default: ()=>Vibes_Vibes
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const horizon_namespaceObject = require("@pcln/horizon");
require("react");
const Vibes = ({ vibes, hotelId })=>{
    if (0 === vibes.length) return null;
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
        className: "relative flex gap-1 py-1",
        children: vibes.map((vibes, index)=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(horizon_namespaceObject.Tooltip, {
                defaultOpen: true,
                closeDelay: 5,
                className: "relative",
                color: "neutral",
                align: "center",
                triggerNode: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(horizon_namespaceObject.Badge, {
                    palette: "success",
                    emphasis: "medium",
                    size: "sm",
                    children: [
                        ' ',
                        vibes.primaryVibe,
                        ' '
                    ]
                }),
                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                    className: "bg-neutral-3 text-neutral-11 text-body3 z-10 px-2 py-1",
                    style: {
                        zIndex: 9999,
                        background: '#fff'
                    },
                    children: vibes.vibeDescription
                })
            }, `${hotelId}-${vibes.vibeDescription}-${index}`))
    });
};
const Vibes_Vibes = Vibes;
exports["default"] = __webpack_exports__["default"];
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "default"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
